// extracted by mini-css-extract-plugin
module.exports = {"main-component":"gameComplete_main-component__Zi9ML"};